// extracted by mini-css-extract-plugin
export default {"parent":"templateCategory_parent__m7VYC","templatesList":"templateCategory_templatesList__90rKA"};